import React, { lazy, Suspense, useContext } from "react";
import { Redirect, useLocation } from "react-router-dom";
import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";

const LoggedInLayout = lazy(() => import("../layout"));

export default function PrivateLayout(props) {
  const { isAuth, loading } = useContext(AuthContext);
  const location = useLocation();
  if (loading) return <BackdropLoading />;
  if (!isAuth) return <Redirect to={{ pathname: "/login", state: { from: location } }} />;
  return <Suspense fallback={<BackdropLoading />}><LoggedInLayout {...props} /></Suspense>;
}
